import type { ReactNode } from 'react';

import { Box } from '@mui/joy';

export const renderOption = (item: ReactNode): ReactNode => (
  <Box sx={{ flexGrow: 1, minWidth: '0', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
    {item}
  </Box>
);
